import React, { useState, useEffect } from 'react';
import { Layout, Menu, Dropdown, Button, Modal, Form, Input, message } from 'antd';
import { DatabaseOutlined, FileTextOutlined, LayoutOutlined, UserOutlined, LogoutOutlined, KeyOutlined, ReadOutlined } from '@ant-design/icons';
import ModuleManager from './components/ModuleManager';
import FieldManager from './components/FieldManager';
import FooterManager from './components/FooterManager';
import NewsManager from './components/NewsManager';
import Login from './components/Login';
import { authAPI } from './api/client';

const { Header, Sider, Content } = Layout;

function App() {
  const [selectedMenu, setSelectedMenu] = useState('modules');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [passwordForm] = Form.useForm();

  // 检查登录状态
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const savedUsername = localStorage.getItem('username');
    if (token && savedUsername) {
      setIsLoggedIn(true);
      setUsername(savedUsername);
    }
  }, []);

  const handleLoginSuccess = () => {
    const savedUsername = localStorage.getItem('username');
    setIsLoggedIn(true);
    setUsername(savedUsername);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('username');
    setIsLoggedIn(false);
    setUsername('');
    message.success('已退出登录');
  };

  const handleChangePassword = async () => {
    try {
      const values = await passwordForm.validateFields();
      await authAPI.changePassword(values.old_password, values.new_password);
      message.success('密码修改成功');
      setChangePasswordVisible(false);
      passwordForm.resetFields();
    } catch (error) {
      message.error('修改密码失败: ' + error.message);
    }
  };

  // 如果未登录，显示登录页面
  if (!isLoggedIn) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  const renderContent = () => {
    switch (selectedMenu) {
      case 'modules':
        return <ModuleManager />;
      case 'fields':
        return <FieldManager />;
      case 'news':
        return <NewsManager />;
      case 'footer':
        return <FooterManager />;
      default:
        return <ModuleManager />;
    }
  };

  const userMenuItems = [
    {
      key: 'changePassword',
      icon: <KeyOutlined />,
      label: '修改密码',
      onClick: () => setChangePasswordVisible(true)
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: 'white',
        fontSize: '20px',
        fontWeight: 'bold'
      }}>
        <span>翻译内容管理系统</span>
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Button type="text" style={{ color: 'white' }} icon={<UserOutlined />}>
            {username}
          </Button>
        </Dropdown>
      </Header>
      <Layout>
        <Sider width={200} style={{ background: '#fff' }}>
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            style={{ height: '100%', borderRight: 0 }}
            onSelect={({ key }) => setSelectedMenu(key)}
          >
            <Menu.Item key="modules" icon={<DatabaseOutlined />}>
              模块管理
            </Menu.Item>
            <Menu.Item key="fields" icon={<FileTextOutlined />}>
              字段管理
            </Menu.Item>
            <Menu.Item key="news" icon={<ReadOutlined />}>
              新闻配置
            </Menu.Item>
            <Menu.Item key="footer" icon={<LayoutOutlined />}>
              页脚管理
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout style={{ padding: '24px' }}>
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            {renderContent()}
          </Content>
        </Layout>
      </Layout>

      {/* 修改密码弹窗 */}
      <Modal
        title="修改密码"
        open={changePasswordVisible}
        onOk={handleChangePassword}
        onCancel={() => {
          setChangePasswordVisible(false);
          passwordForm.resetFields();
        }}
      >
        <Form form={passwordForm} layout="vertical">
          <Form.Item
            name="old_password"
            label="旧密码"
            rules={[{ required: true, message: '请输入旧密码' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="new_password"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="确认新密码"
            dependencies={['new_password']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
}

export default App;

